import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { CompanyClassModel } from 'src/models';

const companyClassAdapter: AdapterFunc<GQL.CompanyClassDbModel, CompanyClassModel> = (input) => ({
  id: input.id,
  name: input.name!,
  description: input.description!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
});

export default companyClassAdapter;
